import { TLanguages } from 'components/logic/LanguageProvider/types/language-provider.interface';

import { isAvailableLanguage } from './is-available-language';
import { isCorrectLanguage } from './is-correct-language';

export const getCorrectQueryLanguage = (lang: string | null): TLanguages | null => {
  if (isCorrectLanguage(lang) && isAvailableLanguage(lang)) {
    return lang;
  }

  return null;
};
